/*eslint-disable react/no-danger*/
import React, {PropTypes} from 'react';
import Button from '../../common/Button';
import {Link} from 'react-router';
import * as PathConstants from '../../../constants/pathConstants';
import CheckBoxInput from '../../common/CheckBoxInput';
import * as userCreationText from '../../../constants/userCreationText';

const UserTermsAndConditionsForm = ({
  form,
  onSubmit,
  onBackButtonClick,
  onClick,
  submitStatus,
  pageNumber,
  pageActive,
  user
}) => {
  let questionCheckBox;
  if (form.formQuestions && form.formQuestions.length > 0) {
    const question = form.formQuestions[0];
    questionCheckBox = (
      <div className="row">
        <div className="col-xs-12 col-sm-9">
          <CheckBoxInput
            name={question.questionName}
            label={form.formInstructions}
            options={question.questionParts[0].questionPartOptions}
            value={user[question.questionName]}
            onChange={onClick}/>
        </div>
      </div>
    );
  }
  return (
    <div hidden={pageNumber != pageActive}>
      <div className="panel" id="user-terms-conditions-panel">
        <div>
          <h2>
            Step 2 of 3: Terms and Conditions
          </h2>
        </div>
        <div className="mobile-border-container">
          <div className="row">
            <div
              className="user-terms-conditions col-xs-12 col-sm-9"
              dangerouslySetInnerHTML={{
              __html: form.formPageHelp
            }}/>
            <div className="col-xs-12 col-sm-9 ">
              <form>
                {questionCheckBox}
                <div className="create-account-btns">
                  <div id="submit-account" className="btn-container pull-right">
                    <Button
                      className="submit-account"
                      value={userCreationText.accountContinueButtonText}
                      onClick={onSubmit}
                      disabled={!submitStatus}/>
                  </div>
                  <div id="cancel-account" className="btn-container pull-right">
                    <Link to={PathConstants.pathToLogin}>
                      Cancel
                    </Link>
                  </div>
                  <div className="user-creation-back-button pull-left">
                    <a onClick={onBackButtonClick}>
                      {userCreationText.backButton}
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UserTermsAndConditionsForm.propTypes = {
  form: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBackButtonClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  pageNumber: PropTypes.number.isRequired,
  pageActive: PropTypes.number.isRequired,
  user: PropTypes.object.isRequired
};

export default UserTermsAndConditionsForm;



/** WEBPACK FOOTER **
 ** ./src/components/account/createAccount/UserTermsAndConditionsForm.js
 **/